import { useState, useCallback } from 'react';

export interface EditingCell {
  rowId: string;
  colId: string;
}

export function useEditingState() {
  const [editingCell, setEditingCell] = useState<EditingCell | null>(null);

  const startEditing = useCallback((rowId: string, colId: string) => {
    setEditingCell({ rowId, colId });
  }, []);

  const commitEdit = useCallback(() => {
    setEditingCell(null);
  }, []);

  const cancelEdit = useCallback(() => {
    setEditingCell(null);
  }, []);

  const isEditing = useCallback((rowId: string, colId: string) => {
    return editingCell?.rowId === rowId && editingCell?.colId === colId;
  }, [editingCell]);

  return {
    editingCell,
    startEditing,
    commitEdit,
    cancelEdit,
    isEditing,
  };
}
